import dayjs from "dayjs";
import { type IUser } from "src/components/shared/UserList/UserList.types";
import { getYachtId } from "src/utils";

import {
  type ISearchForm,
  type ISearchFormWithUndefined,
  type ISearchResult,
} from "./SearchPage.types";

export const searchInitialValues: ISearchForm = {
  sort: "desc",
  startDate: null,
  endDate: null,
  explicit: "",
  mention: "",
  opened: "",
  status: "*",
  sub: false,
  urn: "",
  ssort: null,
  sdir: null,
  type: "",
  dateType: "entrydate",
};

export const mapSearchUsers = (data: any) => {
  const names = (
    data.data
      ? data.data.map((user: IUser) => {
          if (user.full_name) {
            return user.full_name;
          }
          if (user.firstname && user.surname) {
            return `${user.firstname} ${user.surname}`;
          }
          return "";
        })
      : []
  ) as string[];

  // Dedupe on a normalized key: the same person can appear once via
  // `full_name` and again via `firstname`/`surname`, and those two sources
  // don't always agree on whitespace/casing, so an exact-match Set lets
  // near-identical names through as separate dropdown entries.
  const seen = new Set<string>();
  const uniqueNames: string[] = [];
  for (const name of names) {
    const trimmed = name.trim().replace(/\s+/g, " ");
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    uniqueNames.push(trimmed);
  }

  return uniqueNames;
};

export const mapSearchResults = (data: any) =>
  (Array.isArray(data.data)
    ? data.data
    : Object.values(data.data)) as ISearchResult[];

export const getSearchScopeParams = (
  type: string | null | undefined,
  id: string | undefined,
): Record<string, any> => {
  if (!type) return { globalSearch: true };
  if (type === "colid") return { isCol: true, colid: id };
  if (["lbeid", "meid", "partid"].includes(type)) return { lbid: id };
  return { globalSearch: true };
};
export const getParams = ({
  sort,
  startDate,
  endDate,
  ...rest
}: ISearchFormWithUndefined) => ({
  asc: sort === "asc",
  desc: sort === "desc",
  startDate: startDate ? dayjs(startDate).format("DD/MM/YYYY") : null,
  endDate: endDate ? dayjs(endDate).format("DD/MM/YYYY") : null,
  yachtid: getYachtId(),
  ...rest,
});
